export default function errorMessage(message = 'Systemfel', { element = document.getElementById('content'), position = 'afterbegin' } = {}) {
  const possibleExistingErrorMessage = element.parentNode.querySelector('.alert--error')
  if (possibleExistingErrorMessage) {
    possibleExistingErrorMessage.parentNode.removeChild(possibleExistingErrorMessage)
  }
  const warning = document.querySelector('[data-fn-warning-icon]')
  element.insertAdjacentHTML(position, `<div class="alert alert--error" role="alert">${warning?.outerHTML}${message}</div>`)
}
